bikeway_home_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large white-bg');

        mapData.pointsLayer.clearLayers();
        mapData.lineStringLayer.clearLayers();
        properties.commentsToggle = false;

    },


    events: function() {
        var self = this;
        self.onLoad();

    }
}